export const getSecureLinkPath = (token = ':token') => `/s/${token}`;
